import { forwardRef } from 'react';
import { Cell } from './Table.Body.Cell';
import styles from './style/Table.module.css';
import { cx } from '@trinity/chat-components/utils';

type TBodyProps = {
  children?: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const TBody = forwardRef<HTMLDivElement, TBodyProps>(({ children, className, ...restProps }, ref) => {
  return (
    <div {...restProps} className={cx(styles.body, className)} ref={ref} role="rowgroup">
      {children}
    </div>
  );
});

TBody.displayName = 'Table.Body.TBody';

type RowProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
} & React.HTMLAttributes<HTMLDivElement>;

const Row = forwardRef<HTMLDivElement, RowProps>(({ children, className, style = {}, ...props }, ref) => {
  return (
    <div className={cx(styles.tr, className)} ref={ref} role="row" style={style} {...props}>
      {children}
    </div>
  );
});

Row.displayName = 'Table.Body.Row';

export const Body = {
  TBody,
  TD: Cell,
  TR: Row,
};
